import { render, staticRenderFns } from "./page-fee.vue?vue&type=template&id=68829580&scoped=true&"
import script from "./page-fee.vue?vue&type=script&lang=js&"
export * from "./page-fee.vue?vue&type=script&lang=js&"
import style0 from "./page-fee.vue?vue&type=style&index=0&id=68829580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68829580",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68829580')) {
      api.createRecord('68829580', component.options)
    } else {
      api.reload('68829580', component.options)
    }
    module.hot.accept("./page-fee.vue?vue&type=template&id=68829580&scoped=true&", function () {
      api.rerender('68829580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/settings/page-fee.vue"
export default component.exports